import { useMemo } from "react";
import { PROFILE_NAME } from "../configuration";
import { useUtagDataScript } from "./useUtagDataScript";
export function useIntegrationScriptQA() {
  const utag_data = useUtagDataScript();
  const script = useMemo(
    () => `
  var utag_data = ${JSON.stringify(utag_data)};
  window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
  window.utag_cfg_ovrd.noview = true;
  (function(a,b,c,d){ 
    a="//tags.tiqcdn.com/utag/basf/${PROFILE_NAME}/qa/utag.js";
    b=document;
    c="script";
    d=b.createElement(c);
    d.src=a;
    d.type="text/java"+c;
    d.async=true;
    a=b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d,a); 
  })();`,
    []
  );

  return script;
}
export function useIntegrationScript() {
  const utag_data = useUtagDataScript();
  const script = useMemo(
    () => `
  var utag_data = ${JSON.stringify(utag_data)};
  window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
  window.utag_cfg_ovrd.noview = true;
  (function(a,b,c,d){ 
    a="https://tags.tiqcdn.com/utag/basf/${PROFILE_NAME}/prod/utag.js"; 
    b=document;
    c="script";
    d=b.createElement(c);
    d.src=a;
    d.type="text/java"+c;
    d.async=true; 
    a=b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d,a); 
  })();`,
    []
  );

  return script;
}
